import { NHDM_VAULT_DOCS } from './constants';
import { DocumentsEntity } from './fetchMedicalRecords';
import fetchWithRefresh from './fetchWithRefresh';

export interface RequestResponse {
    documents: DocumentsEntity[];
}

interface RequestData {
    patient: {
        oid: string;
        health_id: string;
    };
    hiu: {
        clinic_id: string;
        d_oid: string;
    };
    consent_id: string;
}

interface Headers {
    [key: string]: string;
}

export default (request: RequestData, headers?: Headers): Promise<RequestResponse> => {
    return fetchWithRefresh(NHDM_VAULT_DOCS, {
        method: 'POST',
        body: JSON.stringify(request),
        headers: {
            'Content-type': 'application/json',
            flow: 'hmis',
            ...(headers || {}),
        },
    }).then((res) => {
        return res.json();
    });
};
